import { OrderData } from '../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'

type ProductsToProcessingTy = {
    units: number
    products: number[]
}
export interface SelectedTableForProcessingTy {
    canceling: ProductsToProcessingTy
    processing: ProductsToProcessingTy
    forSend: ProductsToProcessingTy
}
export const parseSelectedTableForProcessing = (completeData: OrderData) => {
    const parsedData: OrderData = JSON.parse(JSON.stringify(completeData))
    const isSelectedTableData = parsedData?.selectedTableData && parsedData?.selectedTableData?.length ? true : false
    const myTableData = parsedData?.selectedTableData?.length ? parsedData?.selectedTableData : parsedData?.tableData
    const result: SelectedTableForProcessingTy = {
        canceling: {
            units: 0,
            products: []
        },
        processing: {
            units: 0,
            products: []
        },
        forSend: {
            units: 0,
            products: []
        }
    }
    for (const element of myTableData) {
        let myElement = element
        if (isSelectedTableData && parsedData?.dictPosTableData?.[myElement.id] !== undefined){
            myElement = parsedData?.tableData[parsedData?.dictPosTableData?.[myElement.id]]
        }
        if (!myElement.processed && myElement.OrderId && myElement?.type !== "addButton") {
            const quantity = parseFloat(myElement.quantity)
            if (quantity === 0 && !myElement.saveRest) {
                result.canceling.products.push(myElement.id)
                result.forSend.products.push(myElement.id)
                result.forSend.units = result.forSend.units + quantity
            } else {
                result.processing.products.push(myElement.id)
                result.processing.units = result.processing.units + quantity
                if (quantity > 0) {
                    result.forSend.products.push(myElement.id)
                    result.forSend.units = result.forSend.units + quantity
                }
            }
        }
    }
    return result
}
